'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isUrl = require('is-url');

var _isUrl2 = _interopRequireDefault(_isUrl);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var requiredUrlPropType = function requiredUrlPropType(props, propName, componentName) {
  var value = props[propName];

  if (value == null || typeof value !== 'string' || !value.startsWith('/') && !(0, _isUrl2.default)(value)) {
    return new TypeError('Invalid URL Prop Value: ' + value + ' for ' + propName + ' in ' + componentName);
  }

  return null;
};

var urlPropType = function urlPropType(props, propName, componentName) {
  if (props[propName] == null) {
    return null;
  }

  return requiredUrlPropType(props, propName, componentName);
};

urlPropType.isRequired = requiredUrlPropType;
exports.default = urlPropType;